import React from 'react'
import ViewScoreForTeacher from '../components/MT_Score/ViewScoreForTeacher'
import ScoreViewHeaderForTeacher from '../components/MT_Score/ScoreViewHeaderForTeacher'

const MtScoreViewScoreForTeacher = () => {
  return (
    <>
    <ScoreViewHeaderForTeacher />
    <ViewScoreForTeacher />
    </>
  )
}

export default MtScoreViewScoreForTeacher